<template>
  <q-bar class="bg-white">
    <q-btn
      dense
      flat
      round
      :to="{ name: 'TradeDetail', params: { serno: serno } }"
    >
      <i class="fas fa-chevron-left"></i>
    </q-btn>
    <div class="col text-center">{{ $t('trade.share.title') }}</div>
  </q-bar>
  <div>
    <div class="q-pl-md q-py-sm text-primary">
      {{ $t('trade.tradesub.serno', { data: serno }) }}
    </div>
    <q-separator />
    <!-- <div class="q-pl-md q-py-sm">
      {{ `${$t('generic.text.password')}: ${trade.password}` }}
    </div> -->
    <q-separator />
    <div class="q-pa-md column items-center">
      <vue-qrcode :value="sharedQrcodeData" :options="{ width: 200 }" />
      <p>{{ $t('trade.share.notice') }}</p>
      <q-btn
        class="full-width"
        color="primary"
        :label="$t('trade.share.withEmail')"
        @click="prompt = true"
      />
    </div>
  </div>
  <q-dialog v-model="prompt" persistent>
    <q-card style="min-width: 350px">
      <q-card-section>
        <div class="text-h6">{{ $t('trade.share.withEmail') }}</div>
      </q-card-section>

      <q-card-section class="q-pt-none">
        <q-form ref="form">
          <q-input
            v-model.trim="form.email"
            dense
            autofocus
            type="email"
            :label="`${$t('personalInfo.email')}`"
            :rules="emailRules"
            @keyup.enter="prompt = false"
          />
        </q-form>
      </q-card-section>

      <q-card-actions align="right" class="text-primary">
        <q-btn v-close-popup flat :label="$t('generic.text.cancel')" />
        <q-btn
          flat
          :label="$t('generic.text.submit')"
          @click="shareWithEmail"
        />
      </q-card-actions>
    </q-card>
  </q-dialog>
</template>

<script>
import VueQrcode from '@chenfengyuan/vue-qrcode';
import { mapActions, mapState } from 'vuex';
import { SHARE_TRADE_TEMPLATE } from '@/constants';

export default {
  components: {
    VueQrcode,
  },
  props: {
    serno: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      prompt: false,
      form: { email: '' },
      emailRules: [
        (v) =>
          !!v ||
          this.$t('generic.error.required', {
            msg: this.$t('personalInfo.email'),
          }),
        (v) =>
          this.$validators.email(v) ||
          this.$t('generic.error.invalidEmailFormat'),
      ],
    };
  },
  computed: {
    ...mapState({
      trade: (state) => state.trade.currentTrade,
      personalInfo: (state) => state.user.personalInfo,
    }),

    sharedQrcodeData() {
      const data = {
        serno: this.serno,
        fromId: this.personalInfo.userid,
        // password: this.password,
        salt: Math.random(),
      };
      console.log(data);
      return JSON.stringify(data);
    },
  },
  methods: {
    ...mapActions({
      sendEmail: 'sendEmail',
    }),

    shareWithEmail() {
      this.$refs.form.validate().then((success) => {
        if (!success) return;

        const sharedLink = `https://vip.kloudhotel.com.tw/account/importReservation?serno=${this.serno}&fromId=${this.personalInfo.userid}`;
        // const sharedLink = `https://53d5-111-252-84-84.jp.ngrok.io/account/importReservation?serno=${this.serno}&fromId=${this.personalInfo.userid}`;
        let bodyHtmlContent = SHARE_TRADE_TEMPLATE;
        bodyHtmlContent = bodyHtmlContent
          .replaceAll('{{name}}', this.personalInfo.name)
          .replaceAll('{{sharedLink}}', sharedLink);

        this.sendEmail({
          to: [this.form.email],
          subject: '浮雲客棧 Kloud Hotel - App 分享訂單',
          bodyHtmlContent,
        })
          .then((resp) => {
            this.prompt = false;
            this.$notify.create({
              message: this.$t('sendEmail.success'),
              position: 'top',
              type: 'positive',
            });
          })
          .catch((err) => {
            console.log(err);

            this.$notify.create({
              message: this.$t('sendEmail.failed'),
              caption: err.response.data,
              position: 'top',
              type: 'negative',
            });
          });
      });
    },
  },
};
</script>
